import { Badge } from "@/components/ui/badge";
import { Building2, FileText, Users, MapPin, CheckSquare, Briefcase } from "lucide-react";

interface ConversationContextProps {
  reference: {
    type: "bid" | "service" | "opportunity" | "location" | "task" | "application";
    id: string;
    title: string;
  };
}

export function ConversationContext({ reference }: ConversationContextProps) {
  // Get appropriate icon and label based on context type
  const getContextInfo = (type: string) => {
    switch (type) {
      case "opportunity":
        return {
          icon: Briefcase,
          label: "Subcontracting Opportunity",
          color: "bg-blue-50 text-blue-700 border-blue-200",
        };
      case "application":
        return {
          icon: FileText,
          label: "Application",
          color: "bg-green-50 text-green-700 border-green-200",
        };
      case "bid":
        return {
          icon: FileText,
          label: "Bid",
          color: "bg-purple-50 text-purple-700 border-purple-200",
        };
      case "service":
        return {
          icon: CheckSquare,
          label: "Service",
          color: "bg-orange-50 text-orange-700 border-orange-200",
        };
      case "location":
        return {
          icon: MapPin,
          label: "Location",
          color: "bg-teal-50 text-teal-700 border-teal-200",
        };
      case "task":
        return {
          icon: CheckSquare,
          label: "Task",
          color: "bg-gray-50 text-gray-700 border-gray-200",
        };
      default:
        return {
          icon: Building2,
          label: "Business Context",
          color: "bg-gray-50 text-gray-700 border-gray-200",
        };
    }
  };

  const contextInfo = getContextInfo(reference.type);
  const Icon = contextInfo.icon;

  return (
    <div className="border-b border-gray-200 bg-gray-50 px-4 py-3">
      <div className="flex items-center gap-2">
        <Icon className="h-4 w-4 text-gray-500" />
        <span className="text-sm text-gray-600">Regarding:</span>
        <Badge variant="outline" className={`${contextInfo.color} font-medium`}>
          {contextInfo.label}
        </Badge>
        <span className="truncate text-sm font-medium text-gray-900">{reference.title}</span>
      </div>
    </div>
  );
}
